import React, { useContext, useState, useRef, useEffect } from 'react';
import { FormContext } from '../../context/FormContext';
import { FaUserCircle } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import Input from "../CustomInput";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const Step7 = ({ nextStep, prevStep }) => {
  const { formData, updateFormData } = useContext(FormContext);
  const [billingContact, setBillingContact] = useState(
    formData.billingContact || {
      sameAsAdmin: false,
      firstName: '',
      lastName: '',
      email: '',
      businessPhone: ''
    }
  );
  const [errors, setErrors] = useState({});
  const stepTitleRef = useRef(null);

  useEffect(() => {
    if (stepTitleRef.current) {
      stepTitleRef.current.focus();
    }
  }, []);

  const handleChange = (field, value) => {
    setBillingContact(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckbox = () => {
    if (!billingContact.sameAsAdmin) {
      setBillingContact({
        sameAsAdmin: true,
        firstName: formData.administrationContact?.firstName || '',
        lastName: formData.administrationContact?.lastName || '',
        email: formData.administrationContact?.email || '',
        businessPhone: formData.administrationContact?.mobilePhone || '',
      });
    } else {
      setBillingContact({
        sameAsAdmin: false,
        firstName: '',
        lastName: '',
        email: '',
        businessPhone: '',
      });
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value.trim().toLowerCase();
    handleChange('email', value);
  };

  const handleNext = () => {
    // Validação dos campos obrigatórios
    if (!billingContact.firstName || !billingContact.lastName || !billingContact.email) {
      setErrors({
        firstName: !billingContact.firstName ? 'Primeiro Nome é obrigatório' : '',
        lastName: !billingContact.lastName ? 'Último Nome é obrigatório' : '',
        email: !billingContact.email ? 'Email é obrigatório' : '',
      });
      return;
    }

    // Validação do formato do email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(billingContact.email)) {
      setErrors(prev => ({ ...prev, email: 'Formato de email inválido (_@_._)' }));
      return;
    }

    // Validação do telefone no padrão E.164 (ex: +5511912341234)
    if (billingContact.businessPhone) {
      const e164Regex = /^\+[1-9]\d{1,14}$/;
      billingContact.businessPhone = billingContact.businessPhone.replace(/\s+/g, '');
      if (!e164Regex.test(billingContact.businessPhone)) {
        setErrors(prev => ({ 
          ...prev, 
          businessPhone: 'Formato de celular inválido (padrão E.164 esperado)' 
        }));
        return;
      }
    }

    updateFormData({ billingContact });
    nextStep();
  };

  return (
    <div>
      <h2 
        ref={stepTitleRef}
        tabIndex="-1"
        className="text-xl text-white font-bold mb-4 focus:outline-none"
      >
        7º Passo: Contato de Cobrança
      </h2>
      <div className="mb-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            checked={billingContact.sameAsAdmin}
            onChange={handleCheckbox}
            className="form-checkbox"
          />
          <span className="ml-2 text-white">O mesmo que o contato administrador do Sistema</span>
        </label>
      </div>
      {/* Os campos são sempre renderizados */}
      <div className="mb-4">
        <Input
          type="text"
          value={billingContact.firstName}
          onChange={(e) => handleChange('firstName', e.target.value)}
          label="Primeiro Nome"
          error={errors.firstName}
          icon={<FaUserCircle className="size-4" />}
        />
      </div>
      <div className="mb-4">
        <Input
          type="text"
          value={billingContact.lastName}
          onChange={(e) => handleChange('lastName', e.target.value)}
          label="Último Nome"
          error={errors.lastName}
          icon={<FaUserCircle className="size-4" />}
        />
      </div>
      <div className="mb-4">
        <Input
          type="email"
          value={billingContact.email}
          onChange={handleEmailChange}
          label="Email"
          error={errors.email}
          icon={<IoMdMail className="size-4" />}
        />
      </div>
      <div className="mb-4">
        <label className="mb-2 block text-sm font-medium leading-6 text-[#f4f4f4]">
          Celular (opcional)
        </label>
        <PhoneInput
          defaultCountry="br"
          value={billingContact.businessPhone}
          onChange={(phone) => handleChange('businessPhone', phone)}
        />
        {errors.businessPhone && (
          <p className="mt-2 text-sm text-red-600">{errors.businessPhone}</p>
        )}
      </div>
      <div className="flex justify-between gap-2">
        <button
          onClick={prevStep}
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 flex items-center gap-2 w-full justify-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          Voltar
        </button>
        <button
          onClick={handleNext}
          className="w-full flex justify-center items-center gap-x-2 rounded-md bg-[#0d6efd] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Seguinte
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Step7;
